import { Checkbox } from "@mui/material";
import { toggleItemInArray } from "helpers/index";
import { IdentifiableWithCalculatedParams, TableSelectedProps } from "layout/TableConstructor/types";

interface RowCheckboxProps<T extends IdentifiableWithCalculatedParams> {
  selectedProps: TableSelectedProps<T["id"]>;
  row: T;
}

const RowCheckbox = <T extends IdentifiableWithCalculatedParams>({ selectedProps, row }: RowCheckboxProps<T>) => {
  const [selected, setSelected] = selectedProps;

  return (
    <Checkbox
      color='primary'
      size='small'
      checked={selected.includes(row.id)}
      disabled={row.checkboxDisabled}
      sx={{ display: "block", width: "fit-content", marginLeft: "auto", marginRight: "auto" }}
      onClick={(e) => {
        e.stopPropagation();

        const newSelected = toggleItemInArray<T["id"]>(selected, row.id);
        setSelected(newSelected);
      }}
    />
  );
};

export default RowCheckbox;
